import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
    class_of_business_id: Yup.object().required("Business is required"),
    offer_details: Yup.array().optional(),
    insurer_id: Yup.string().required("Insurer is required"),
    premium: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Premium is required"),
    policy_number: Yup.string().required("Policy Number is required"),
    insured_by: Yup.string().required("Insured is required"),
    sum_insured: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Sum Insured is required"),
    rate: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Rate is required"),
    facultative_offer: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Facultative Offer is required"),
    commission: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Commission is required"),
    brokerage: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Brokerage is required"),
    currency: Yup.string().required("Currency is required"),
    risk_location: Yup.string().required("Risk Location is required"),
    period_of_insurance_from: Yup.date().required(
        "Insurance Start Date is required",
    ),
    period_of_insurance_to: Yup.date()
        .min(
            Yup.ref("period_of_insurance_from"),
            "End Date must be greater than Start Date",
        )
        .required("Insurance End Date is required"),
    comment: Yup.string().notRequired(),
});

export const validationSchemaKEK = Yup.object().shape({
    addExchangeRate: Yup.boolean().notRequired(),
    createForRetroCedent: Yup.boolean().notRequired(),
    include_nkrol_comment: Yup.boolean().notRequired(),
    class_of_business_id: Yup.object().required("Business is required"),
    offer_details: Yup.array().optional(),
    insurer_id: Yup.string().required("Insurer is required"),
    premium: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Premium is required"),
    policy_number: Yup.string().required("Policy Number is required"),
    insured_by: Yup.string().required("Insured is required"),
    sum_insured: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Sum Insured is required"),
    rate: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Rate is required"),
    facultative_offer: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Facultative Offer is required"),
    commission: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Commission is required"),
    brokerage: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Brokerage is required"),
    currency: Yup.string().required("Currency is required"),
    period_of_insurance_from: Yup.date().required(
        "Insurance Start Date is required",
    ),
    period_of_insurance_to: Yup.date()
        .min(
            Yup.ref("period_of_insurance_from"),
            "End Date must be greater than Start Date",
        )
        .required("Insurance End Date is required"),
    comment: Yup.string().notRequired(),
    reinsurer_id: Yup.string().when("createForRetroCedent", {
        is: true,
        then: (schema) => schema.required("Reinsurer is required"),
    }),
    business_state: Yup.string().required("Business State is required"),
    co_insurance_share: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .notRequired(),
    ex_currency: Yup.string().when("addExchangeRate", {
        is: true,
        then: (schema) => schema.required("Exchange Currency is required"),
    }),
    ex_rate: Yup.number().when("addExchangeRate", {
        is: true,
        then: (schema) =>
            schema
                .min(1, "Number must be greater than 1")
                .typeError("Must be a number")
                .required("Exchange Rate is required"),
    }),
    information_comment: Yup.string().when("include_nkrol_comment", {
        is: true,
        then: (schema) => schema.required("Information Comment is required"),
        otherwise: (schema) => schema.notRequired(),
    }),
    payment_type: Yup.string().required("Payment Type is required"),
    no_of_installments: Yup.string().when("payment_type", {
        is: "instalment",
        then: (schema) => schema.required("Number of installments is required"),
    }),
});

export const validationSchemaKEKUpdate = Yup.object().shape({
    class_of_business_id: Yup.object().required("Business is required"),
    offer_details: Yup.array().notRequired(),
    insurer_id: Yup.string().required("Insurer is required"),
    premium: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Premium is required"),
    policy_number: Yup.string().required("Policy Number is required"),
    insured_by: Yup.string().required("Insured is required"),
    sum_insured: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Sum Insured is required"),
    rate: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Rate is required"),
    facultative_offer: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Facultative Offer is required"),
    commission: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Commission is required"),
    brokerage: Yup.number()
        .min(0, "Number must be greater than 0")
        .typeError("Must be a number")
        .required("Brokerage is required"),
    currency: Yup.string().required("Currency is required"),
    period_of_insurance_from: Yup.date().required(
        "Insurance Start Date is required",
    ),
    period_of_insurance_to: Yup.date()
        .min(
            Yup.ref("period_of_insurance_from"),
            "End Date must be greater than Start Date",
        )
        .required("Insurance End Date is required"),
    comment: Yup.string().notRequired(),
});

export const createDetailsInitialValues = {
    createForRetroCedent: false,
    addExchangeRate: false,
    include_nkrol_comment: false,
    class_of_business_id: "",
    offer_details: [],
    insurer_id: "",
    premium: "",
    policy_number: "",
    insured_by: "",
    sum_insured: "",
    rate: "",
    facultative_offer: "",
    commission: "",
    brokerage: "",
    currency: "",
    period_of_insurance_from: "",
    period_of_insurance_to: "",
    comment: "",
    reinsurer_id: "",
    business_state: "",
    co_insurance_share: "",
    ex_currency: "",
    ex_rate: "",
    information_comment: "",
    payment_type: "payable_in_full",
    no_of_installments: "",
    risk_location: "",
};

export const updateDetailsInitialValues = {
    ...createDetailsInitialValues,
    old_class_of_business_id: "",
    old_offer_detail: [],
};
